/* esm.sh - rxjs@7.8.2/dist/esm/internal/operators/concatMap */
import{mergeMap as i}from"rxjs/dist/esm/internal/operators/mergeMap";import{isFunction as m}from"rxjs/dist/esm/internal/util/isFunction";function t(n,o){return m(o)?i(n,o,1):i(n,1)}export{t as concatMap};
//# sourceMappingURL=concatMap.mjs.map